export function maskCpf(v: string) {
  if (!v) return;
  v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
  v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
  v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
  //de novo (para o segundo bloco de números)
  v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
  return v;
}

export function maskCnpj(v: string) {
  if (!v) return;
  v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
  v = v.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
  v = v.replace(/\.(\d{3})(\d)/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
  v = v.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
  return v;
}
export function maskPhone(value: string) {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{2})(\d)/, "($1) $2");
  value = value.replace(/(\d)(\d{4})$/, "$1-$2");
  return value;
}

export function maskCep(value: string) {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{5})(\d)/, "$1-$2");
  return value;
}

export function removeDigitos(s: string) {
  if (!s) return "";
  const newValue = s.replace(/\D/g, "");

  return newValue;
}

export function removerCaracteresEspeciais(s: string) {
  if (!s) return;
  return s.replace(/[^a-zA-Z0-9]/g, "");
}

export function maskMoney(value: number): string {
  if (value === null || value === undefined) return "R$ 0,00";

  // Divide por 100 para posicionar a vírgula corretamente
  const floatValue = value / 100;

  // Formata como moeda brasileira
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(floatValue);
}

export const formatMoneyBRL = (value: number | string): string => {
  // Se for string, remove tudo que não for número e converte para número
  const numericValue =
    typeof value === "string" ? parseInt(value.replace(/\D/g, ""), 10) : value;

  if (isNaN(numericValue)) return "R$ 0,00";

  // Divide por 100 apenas se for um número inteiro (valor em centavos)
  return (numericValue / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};
